export enum AppPaths {
	PRODUCT_TYPES = 'personalizacja',
	FORM = 'form',
	PASSWORD_RESET = 'password-reset',
	PASSWORD_CHANGE = 'password-change',
	LOGIN = 'login',
	REGISTER = 'register',
	ACCOUNT = 'account',
	ACCOUNT_PROJECTS = 'projects',
	ACCOUNT_ORDERS = 'orders',
	ACCOUNT_FORM_DETAILS = 'details',
	ACCOUNT_COMPANY_SETTINGS = 'company-settings',
	ACCOUNT_SETTINGS = 'settings',
	ACCOUNT_PROJECT_DETAILS = 'details',
	ACCOUNT_ORDER_DETAILS = 'details',
	ACCOUNT_CART = 'cart',
	ACCOUNT_FORMS = 'forms',
}
